import _ from "lodash"
import StackedHorizontalBar from "components/StackedHorizontalBar"

const lotTypeBuilderStackedBar = (props, state) => {
	var dataArray = {}
	let model = {}
	let sales, busts
	if(_.isEmpty(state)){
		// Widget
		sales = props.payload.sales.current
		busts = props.payload.bustouts.current
	}
	else {
		// Weekly
		sales = state.sales
		busts = state.bustouts
	}
	_.forEach(sales, (v) => {
		let type = _.find(props.payload.public.lot_types, { id: v.lot_type })
		if (!type) {
			return
		}
		if (!model.hasOwnProperty(type.name)) {
			model[type.name] = 0
		}
	})
	_.forEach(busts, (v) => {
		let type = _.find(props.payload.public.lot_types, { id: v.lot_type })
		if (!type) {
			return
		}
		if (!model.hasOwnProperty(type.name)) {
			model[type.name] = 0
		}
	})
	_.forEach(sales, (v) => {
		if (!v.builder || v.cancel_date || v.transfer_date || !v.lot_type) {
			return
		}
		let type = _.find(props.payload.public.lot_types, { id: v.lot_type })
		let builder = _.find(props.payload.public.builders, { id: v.builder })
		if (!type || !builder) {
			return
		}

		let path = `${builder.name}.${type.name}`
		if (_.has(dataArray, path)) {
			dataArray[builder.name][type.name]++
		} else {
			dataArray[builder.name] = _.clone(model)
			dataArray[builder.name][type.name]++
		}
	})
	_.forEach(busts, (v) => {
		if (!v.builder || v.cancel_date || v.transfer_date || !v.lot_type) {
			return
		}
		let type = _.find(props.payload.public.lot_types, { id: v.lot_type })
		let builder = _.find(props.payload.public.builders, { id: v.builder })
		if (!type || !v.builder) {
			return
		}
		let path = `${builder.name}.${type.name}`
		if (_.has(dataArray, path)) {
			dataArray[builder.name][type.name]--
		} else {
			dataArray[builder.name] = _.clone(model)
			dataArray[builder.name][type.name]--
		}
	})
	// Create series
	let series = []
	_.forEach(dataArray, (v, k) => {
		series.push({
			name: k,
			data: Object.values(v),
		})
	})
	series = _.sortBy(series, "name")
	//console.log(series, model)
	return (
		<>
			<h3 className="statBox__title">
				<span className="bug">YTD</span> Sales By Lot Type
			</h3>
			<StackedHorizontalBar series={series} categories={Object.keys(model)} />
		</>
	)
}

export default lotTypeBuilderStackedBar
